.container {
  position: fixed;
  right: var(--t-spacing-3);
  bottom: var(--t-spacing-3);
  display: flex;
  flex-direction: column-reverse;
  gap: var(--t-spacing-2);
  pointer-events: none;
}

.container > * {
  pointer-events: auto;
}

@media (max-width: 768px) {
  .container {
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
  }
}
